// Texts of the slate library screen (docs/design/i18n.md).

import { defineMessages } from '@/shared/i18n'

export const messages = defineMessages({
  ru: {
    title: 'Заставки',
    hint:
      'Заставки площадки: загрузите ролик с картинкой и звуком (mp4, mov, ts или mkv). Ролик подготовится за минуту-две; пока он не готов, выбрать его нельзя. Готовый ролик выбирается входом «файл из библиотеки» в форме канала и играет по кругу.',
    site: 'Площадка',
    allSites: 'все площадки',
    colName: 'Имя',
    colSite: 'Площадка',
    colState: 'Состояние',
    colDuration: 'Длительность',
    colSize: 'Размер',
    colVideo: 'Видео',
    colAudio: 'Звук',
    colVariants: 'Варианты',
    colActions: 'Действия',
    preview: 'Предпросмотр',
    delete: 'Удалить',
    empty: 'В библиотеке пока нет ни одного файла.',
    loading: 'Загрузка…',
    uploadTitle: 'Загрузить файл',
    uploadJump: 'Загрузить заставку',
    chooseSite: 'выберите площадку',
    fieldName: 'Название',
    fieldNameHint: 'Как показывать в списке — не имя файла.',
    fieldFile: 'Файл',
    fieldFileHint: 'mp4, mov, ts или mkv, до {mb} МБ; PNG — картинка для логотипа пресета видео',
    uploading: 'Загружаем… {percent}%',
    upload: 'Загрузить',
    deleteTitle: 'Удалить заставку?',
    deleteBody: '«{name}» и все подготовленные варианты будут удалены безвозвратно.',
    deleteNote: 'Если файл сейчас играет входом какого-то канала, пульт откажет и назовёт этот канал.',
    previewLoading: 'Загрузка оригинала…',
    previewUnavailable: 'Просмотр в этом окружении недоступен.',
    previewNoPlayBefore: 'Контейнер «{container}» браузер не проигрывает напрямую —',
    previewDownload: 'скачайте файл',
    previewNoPlayAfter: ', чтобы посмотреть.',
    uploadedAt: 'Загружен {time}',
    preparedAt: ', подготовлен {time}',
    close: 'Закрыть',
    errChooseFile: 'выберите файл',
    errFileTooBig: 'файл больше {mb} МБ — сократите или пережмите клип',

    // errors.ts
    uploadTooLarge: 'Файл больше {mb} МБ — сократите или пережмите клип.',
    uploadNetwork:
      'Загрузка не удалась: соединение с сервером пульта оборвалось. Часто это значит, что файл больше {mb} МБ — сервер обрывает такую загрузку, не дожидаясь ответа; если файл меньше, дело в том, что сервер пульта недоступен. Эфир при этом продолжается.',
    assetInUse: {
      one: 'Заставка используется каналом: {names}.',
      few: 'Заставка используется каналами: {names}.',
      many: 'Заставка используется каналами: {names}.',
      other: 'Заставка используется каналами: {names}.',
    },
    // UIX-NIGHT: a PNG that is a transcode preset's logo read "used by a channel".
    logoInUse: {
      one: 'Этот PNG — логотип пресета перекодирования {names}: сначала уберите логотип из пресета.',
      few: 'Этот PNG — логотип пресетов перекодирования {names}: сначала уберите логотип из пресетов.',
      many: 'Этот PNG — логотип пресетов перекодирования {names}: сначала уберите логотип из пресетов.',
      other: 'Этот PNG — логотип пресетов перекодирования {names}: сначала уберите логотип из пресетов.',
    },
    quotedName: '«{name}»',

    // format.ts
    stateUploaded: 'загружен',
    statePreparing: 'готовится',
    stateReady: 'готов',
    stateFailed: 'ошибка',
    fps: '{fps} к/с',
    noAudio: 'нет звука или не измерен',
    sampleRate: '{rate} Гц',
    channelCount: '{count} кан.',
    variantsPreparing: 'готовится…',
    variantsNone: 'не подготовлен',
    variantsOf: '{count} из {max} вариантов',
  },
  en: {
    title: 'Slates',
    hint:
      'Slates of a site: upload a clip with picture and sound (mp4, mov, ts or mkv). It gets ready in a minute or two; until then it cannot be picked. A ready clip is chosen as a “file from the slate library” input in the channel form and plays in a loop.',
    site: 'Site',
    allSites: 'all sites',
    colName: 'Name',
    colSite: 'Site',
    colState: 'State',
    colDuration: 'Duration',
    colSize: 'Size',
    colVideo: 'Video',
    colAudio: 'Audio',
    colVariants: 'Variants',
    colActions: 'Actions',
    preview: 'Preview',
    delete: 'Delete',
    empty: 'The library has no files yet.',
    loading: 'Loading…',
    uploadTitle: 'Upload file',
    uploadJump: 'Upload a slate',
    chooseSite: 'choose a site',
    fieldName: 'Name',
    fieldNameHint: 'How it is shown in the list, not the file name.',
    fieldFile: 'File',
    fieldFileHint: 'mp4, mov, ts or mkv, up to {mb} MB; PNG: a picture for the logo of a video preset',
    uploading: 'Uploading… {percent}%',
    upload: 'Upload',
    deleteTitle: 'Delete the slate?',
    deleteBody: '“{name}” and all its prepared variants will be deleted for good.',
    deleteNote: 'If the file is playing as an input of a channel right now, the console refuses and names that channel.',
    previewLoading: 'Loading the original…',
    previewUnavailable: 'Preview is not available in this environment.',
    previewNoPlayBefore: 'The browser cannot play the “{container}” container directly:',
    previewDownload: 'download the file',
    previewNoPlayAfter: ' to watch it.',
    uploadedAt: 'Uploaded {time}',
    preparedAt: ', prepared {time}',
    close: 'Close',
    errChooseFile: 'choose a file',
    errFileTooBig: 'the file is larger than {mb} MB: trim or re-encode the clip',

    uploadTooLarge: 'The file is larger than {mb} MB: trim or re-encode the clip.',
    uploadNetwork:
      'Upload failed: the connection to control dropped. This often means the file is larger than {mb} MB (control cuts such an upload off without answering); if the file is smaller, control is unavailable. The broadcast keeps going.',
    assetInUse: {
      one: 'The slate is used by channel {names}.',
      other: 'The slate is used by channels {names}.',
    },
    logoInUse: {
      one: 'This PNG is the logo of transcode preset {names}: remove the logo from the preset first.',
      other: 'This PNG is the logo of transcode presets {names}: remove the logo from the presets first.',
    },
    quotedName: '“{name}”',

    stateUploaded: 'uploaded',
    statePreparing: 'preparing',
    stateReady: 'ready',
    stateFailed: 'error',
    fps: '{fps} fps',
    noAudio: 'no audio or not measured',
    sampleRate: '{rate} Hz',
    channelCount: '{count} ch',
    variantsPreparing: 'preparing…',
    variantsNone: 'not prepared',
    variantsOf: '{count} of {max} variants',
  },
})
